export default __webpack_public_path__ + "static/media/world-c-title.dbad6bb9.png";